import { useUserProfile } from "components";
import { IUserProfile } from "interfaces";

export const useApp = (): IUserProfile['app'] => {
  const { userProfile } = useUserProfile();
  return userProfile!.app;
}